<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "ContestActionTemplate",
	};
</script>

<style scoped>

</style>
